import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import message from './MessageReducer';

export default combineReducers({
    toastr: toastrReducer,
    message
});
